module.exports = __webpack_public_path__ + "static/media/sf-test-6.cf5c36f1.mp3";